import { RebootClientProvider } from "@reboot-dev/reboot-react";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "leaflet/dist/leaflet.css";
import Pages from "./pages";
import "./components/Layout.css";
import "./styles/AdminGamePage.css";
import "./styles/UserGamePage.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <RebootClientProvider url={process.env.REACT_APP_REBOOT_URL as string}>
      <Pages />
    </RebootClientProvider>
  </React.StrictMode>
);

reportWebVitals();
